import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-docusign-success',
  templateUrl: './docusign-success.component.html',
  styleUrls: ['./docusign-success.component.css']
})
export class DocusignSuccessComponent implements OnInit {

  envelopeId : string = "";
  destinationEmail : string = "";

  constructor(private router: ActivatedRoute) { }

  ngOnInit(): void {
    let id =  this.router.snapshot.queryParamMap.get('envId');
    let destinationEmail =  this.router.snapshot.queryParamMap.get('destEmail');

    if (typeof(id) === 'string') {
      this.envelopeId = id;
    }

    if (typeof(destinationEmail) === 'string') {
      this.destinationEmail = destinationEmail;
    }
  }
}
